export default __webpack_public_path__ + "static/media/payment-card.27c7b47c.svg";